export default{

    passwordsMatch: 'Passwords must match',
    general: 'Something went wrong',
    retry: 'Please try again. If the error persists, try again later',
    invalidDate: 'The date you have entered is invalid',
    invalidTime: 'The time you have entered is invalid',
    notSameChart: 'You can\'t use the same chart twice',
}